import { render, staticRenderFns } from "./subprogram-nba-standings-page.vue?vue&type=template&id=c3269a16&scoped=true&"
import script from "./subprogram-nba-standings-page.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-standings-page.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-standings-page.vue?vue&type=style&index=0&id=c3269a16&lang=scss&scoped=true&"
import style1 from "./subprogram-nba-standings-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3269a16",
  null
  
)

export default component.exports